export const GRADIENT_CLASSES = {
    rainbow: ['bg-gradient-rainbow'],
    pink: ['bg-gradient-pink'],
    green: ['bg-gradient-green'],
    blue: ['bg-gradient-blue'],
    purple: ['bg-gradient-purple'],
};
